import { useEffect } from 'react';
import {
  EntityListProvider,
  useEntityList,
} from '@backstage/plugin-catalog-react';
import { CatalogTable } from '@agilelab/plugin-wb-builder-catalog';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { PracticeShaperFilters } from '@agilelab/plugin-wb-practice-shaper';
import {
  WbCardContent,
  UserListPicker as FavouritesPicker,
  WbButton,
  EntityServiceAccountFilter,
  EntityRefreshFilter,
  usePermissions,
} from '@agilelab/plugin-wb-platform';
import { Paper } from '@material-ui/core';
import { useState } from 'react';
import { CreateServiceAccountDrawer } from './components/CreateServiceAccountDrawer';
import { DeleteServiceAccountDialog } from './components/DeleteServiceAccountDialog';
import { useServiceAccountActions } from './components/ServiceAccountActionsColumn';
import { Entity } from '@backstage/catalog-model';
import { EditServiceAccountDrawer } from './components/EditServiceAccountDrawer';
import { platformUsersServiceAccountEditPermission } from '@agilelab/plugin-wb-rbac-common';

const InitializeFilter = () => {
  const { updateFilters } = useEntityList<PracticeShaperFilters>();

  useEffect(() => {
    const filters: Partial<PracticeShaperFilters> = {
      kindList: new EntityServiceAccountFilter(true),
    };
    updateFilters(filters);
  }, [updateFilters]);

  return null;
};

const ServiceAccountPageContent = () => {
  const [createOpen, setCreateOpen] = useState(false);

  const [editOpen, setEditOpen] = useState(false);
  const [editedServiceAccount, setEditedServiceAccount] =
    useState<Entity | null>(null);

  const [serviceAccountToDelete, setServiceAccountToDelete] =
    useState<Entity | null>(null);

  const { updateFilters } = useEntityList<PracticeShaperFilters>();

  const refreshTable = () => {
    updateFilters({
      generates: new EntityRefreshFilter(Date.now().toString()),
    });
  };

  const { allAllowed: allowed } = usePermissions([
    {
      permission: platformUsersServiceAccountEditPermission,
    },
  ]);

  return (
    <Paper style={{ height: '100%' }}>
      <WbCardContent style={{ paddingBottom: 0 }}>
        <InitializeFilter />
        <CatalogTable
          preUrl="/platform-settings"
          columnKind="user"
          actions={useServiceAccountActions({
            allowed,
            onEdit: serviceAccount => {
              setEditedServiceAccount(serviceAccount);
              setEditOpen(true);
            },
            onDelete: serviceAccount => {
              setServiceAccountToDelete(serviceAccount);
            },
          })}
          filtersNode={
            <>
              <FavouritesPicker />
            </>
          }
          actionsNode={
            <>
              {allowed && (
                <WbButton
                  label="Add Service Account"
                  startIcon={<AddCircleIcon />}
                  color="primary"
                  onClick={() => setCreateOpen(true)}
                />
              )}
            </>
          }
          limit={25}
        />
      </WbCardContent>
      {allowed && (
        <>
          <CreateServiceAccountDrawer
            open={createOpen}
            setOpen={setCreateOpen}
            onCreated={refreshTable}
          />
          <EditServiceAccountDrawer
            serviceAccount={editedServiceAccount!}
            open={editOpen}
            setOpen={setEditOpen}
            onEdited={refreshTable}
          />
          <DeleteServiceAccountDialog
            serviceAccountToDelete={serviceAccountToDelete}
            onDeleted={refreshTable}
            onClose={() => {
              setServiceAccountToDelete(null);
            }}
          />
        </>
      )}
    </Paper>
  );
};

export const ServiceAccountPage = () => {
  return (
    <EntityListProvider pagination={{ limit: 25 }}>
      <ServiceAccountPageContent />
    </EntityListProvider>
  );
};
